import { PrimaryButton, SecondaryButton } from '@library/components/buttons';

type NavigationStep = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
};

export interface StepperNavigationProps {
  back: NavigationStep;
  currentStep: number;
  next: NavigationStep;
}

export const StepperNavigation = ({
  currentStep,
  back,
  next
}: StepperNavigationProps) => {
  const backLabel = back.label ?? 'Back';
  const nextLabel = next.label ?? 'Next';

  return (
    <div className="py-4">
      <div className="bg-soFresh-130 flex h-16 w-full items-center justify-end gap-4 rounded-md p-4">
        {currentStep && (
          <SecondaryButton
            disabled={back.disabled}
            handleOnClick={back.onClick}
            title={backLabel}
          >
            {backLabel}
          </SecondaryButton>
        )}
        <PrimaryButton
          disabled={next.disabled}
          handleOnClick={next.onClick}
          title={nextLabel}
        >
          {nextLabel}
        </PrimaryButton>
      </div>
    </div>
  );
};
